<template>
  <div
    @click="goToInstruction"
    :class="{
      'bg-pitch-black': !instruction.hasNewUpdate,
      'bg-dark-grey': instruction.hasNewUpdate,
      'px-4 pr-5 pt-3 pb-4 border-b border-total-white-500 flex flex-col items-center w-full': true,
    }"
    class="cursor-pointer"
  >
    <!-- Top Section -->
    <div class="flex w-full justify-between items-center">
      <div class="flex text-left items-center">
        <h3 class="md:text-lg font-bold">
          {{ instruction.name || "Untitled Instruction" }}
          <span
            v-if="instruction.is_default"
            class="ml-2 inline-block text-xs whitespace-nowrap text-prime-golden bg-dark-grey rounded-md px-2 py-1"
          >
            default
          </span>
        </h3>
        <!-- Default text next to the instruction name -->
      </div>
      <!-- Fork Icon -->
      <div
        class="flex text-prime-golden gap-2 cursor-pointer"
        @click.stop="forkInstruction"
      >
        <div class="text-prime-golden font-semibold text-md">fork</div>
        <img src="../assets/images/fork-icon.svg" />
      </div>
    </div>

    <!-- Bottom Section -->
    <div
      :class="{
        'bg-pitch-black': !instruction.hasNewUpdate,
        'bg-dark-grey': instruction.hasNewUpdate,
        'rounded-lg shadow-md mt-2 mb-1 flex justify-between items-center w-full': true,
      }"
    >
      <div class="text-left">
        <p class="text-md text-total-white-800">
          <span class="font-semibold"> Instructions ID</span>
          {{ instruction.id || "Not Assigned" }}
        </p>
        <p class="text-sm mt-2 text-total-white-700">
          last updated at
          {{ instruction.date_updated ? parseDate(instruction.date_updated) : "N/A" }}
        </p>
      </div>

      <!-- Right Icon -->
      <div class="text-prime-golden flex flex-col items-end mt-4">
        <img
          src="@/assets/images/right-chevron.svg"
          alt="Right Chevron"
          width="16"
          height="16"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { parseDate } from "@/misc/util";

const props = defineProps({
  instruction: {
    type: Object,
    required: true,
  },
});

const router = useRouter();

// Navigate to View Instruction Page
const goToInstruction = () => {
  router.push({
    name: "ViewInstructionPage",
    params: { id: props.instruction.id },
  });
};

// Navigate to Create Instruction Page (Forked)
const forkInstruction = () => {
  router.push({
    name: "CreateInstructionsPage",
    query: {
      id: props.instruction.id,
    },
  });
};
</script>

<style scoped>
/* Add specific styles here if needed */
</style>
